import { SearchOptions, SearchResponse } from '@algolia/client-search';
import { Injectable } from '@angular/core';
import { environment } from '@environment';
import { YouthInfoCenterListItem } from '@models/youth-info-center/youth-info-center';
import { AlgoliaClientService } from '@wizbii/algolia';
import { SearchIndex } from 'algoliasearch';
import { from, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PublicInstitutesWebservice {
  private readonly index: SearchIndex;

  constructor(private readonly algoliaClientService: AlgoliaClientService) {
    this.index = this.algoliaClientService.client.initIndex(environment.algolia.index.institutes) as SearchIndex;
  }

  getInstitutes(searchParams?: SearchOptions): Observable<SearchResponse<YouthInfoCenterListItem>> {
    return from(
      this.index.search<YouthInfoCenterListItem>('', { ...searchParams, facetFilters: searchParams?.facetFilters })
    );
  }
}
